// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3g7S8","image":"Header_image__3DQv9","name":"Header_name__3jI4_","info":"Header_info__zDM4t","infoRow":"Header_infoRow__-gGUI"};